import { bound } from "@frui.ts/helpers/dist";
import * as React from "react";
import MaskedInput from "react-text-mask";

import { getValidationMessage } from "@frui.ts/validation";
import type { IBindingProps } from "@frui.ts/views";
import { BindingComponent } from "@frui.ts/views";
import { Observer } from "mobx-react-lite";

import type { FormControlProps } from "react-bootstrap";
import { Form } from "react-bootstrap";
import type { CommonInputProps } from "@frui.ts/bootstrap/dist/controls/commonInputProps";
import type { InputProps } from "@frui.ts/bootstrap/dist/controls/input";
import { createAutoCorrectedDatePipe } from "text-mask-addons/dist/textMaskAddons";
import { isTimeFormat } from "utils/helpers";

export default class TimeInput<TTarget> extends BindingComponent<
  TTarget,
  FormControlProps & InputProps & CommonInputProps & IBindingProps<TTarget>
> {
  render() {
    return <Observer render={this.renderInner} />;
  }

  @bound protected renderInner() {
    const { target, property } = this.props as { target: TTarget; property: keyof TTarget & string }; // the cast is a TS compiler workaround
    const { disabled, noValidation, errorMessage, placeholder, isInvalid, onBlur, className } = this.inheritedProps;
    const validationError = noValidation !== true && (errorMessage || getValidationMessage(target, property));
    const autoCorrectedDatePipe = createAutoCorrectedDatePipe("HH:MM:SS");

    return (
      <>
        <MaskedInput
          mask={[/[0-9]/, /[0-9]/, ":", /[0-9]/, /[0-9]/, ":", /[0-9]/, /[0-9]/]}
          className={`p-2 form-control ${className ? className : "time-control"} ${
            validationError || isInvalid ? "is-invalid" : ""
          }`}
          placeholder={placeholder ? placeholder : "00:00:00"}
          disabled={disabled}
          keepCharPositions={true}
          guide={true}
          onBlur={onBlur}
          pipe={autoCorrectedDatePipe}
          value={this.value}
          onChange={this.handleValueChanged}
        />
        {validationError && <Form.Control.Feedback type="invalid">{validationError}</Form.Control.Feedback>}
      </>
    );
  }

  @bound protected handleValueChanged(e: React.FormEvent<any>) {
    const target = e.target as HTMLInputElement;
    let valueWithoutMask: string | undefined = target.value.replace(/_/g, "");

    if (!isTimeFormat(valueWithoutMask)) {
      valueWithoutMask = undefined;
    }

    this.setValue(valueWithoutMask);
  }
}
